<template>
    <v-sheet>
        <table class="board-view">
            <tr>
                <th colspan="2">{{ board.subject }}</th>
            </tr>
            <tr>
                <td colspan="2">
                    <span class="grey--text">작성일 : {{ $dayjs(board.createdAt).format("YYYY-MM-DD") }}</span>
                </td>
            </tr>
            <tr v-if="board?.upload">
                <td colspan="2">
                    {{ $t("common.attachments") }} : <v-icon>mdi-paperclip</v-icon>
                    <a @click="download(board.files[0], board.files[0].name.split('/').pop())" style="text-decoration: underline">{{ board.files[0].fileName }}</a>
                </td>
            </tr>
            <tr>
                <td colspan="2" class="content_box">
                    <div v-html="board.content"></div>
                </td>
            </tr>
        </table>

        <div class="mt-24">
            <div class="v-btn--group d-flex justify-end">
                <v-btn color="grey lighten-3" tile outlined @click="$router.go(-1)" large>
                    <span class="grey--text">리스트</span>
                </v-btn>
            </div>
        </div>
    </v-sheet>
</template>

<script>

export default {
    props: {
        board: { type: Object, default: null },
    },
};
</script>